import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-armenia-page05',
  templateUrl: './armenia-page05.component.html',
  styleUrls: ['./armenia-page05.component.css']
})
export class ArmeniaPage05Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
